import { ArpMedia, PaginatedResponse } from '@arpeggi/shared'
import axios from '../../../__legacy__/lib/axios'
import { BasePaginationParams } from '../types'

export const getSamplePackRemixes = async (samplePackId: number, params: BasePaginationParams) => {
  const { data } = await axios.get<PaginatedResponse<ArpMedia>>(
    `/api/v2/sample-packs/${samplePackId}/remixes`,
    { params }
  )

  return data
}
